import * as types from './actionTypes';

export function updateGeosuggestLanguageSettings(setting) {
    return dispatch => {
        dispatch({ type: types.UPDATE_GEOSUGGEST_SETTINGS, setting });
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/UtilsActions.js